<template>
  <div class="simple-button">
    <button
      v-if="!to && !href"
      @click="clickHandler"
      class="simple-button__button"
      :class="({ '-light': light }, { '-large': large })"
    >
      {{ title }}
    </button>
    <router-link
      v-if="to"
      :to="to"
      class="simple-button__button"
      :class="({ '-light': light }, { '-large': large })"
    >
      {{ title }}
    </router-link>
    <a
      v-if="href"
      :href="href"
      :target="target"
      class="simple-button__button"
      :class="({ '-light': light }, { '-large': large })"
    >
      {{ title }}
    </a>
  </div>
</template>

<script>
export default {
  name: "SimpleButton",
  props: {
    to: {
      type: String,
      default: null,
      required: false
    },
    href: {
      type: String,
      default: null,
      required: false
    },
    target: {
      type: String,
      default: "_blank",
      required: false
    },
    title: {
      type: String,
      default: null
    },
    light: {
      type: Boolean,
      default: false,
      required: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickHandler: function() {
      return this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.simple-button {
  &__button {
    background: theme-color("accent-2");
    border-radius: sizes("border-radius");
    border: 0;
    box-shadow: theme-color("shadow");
    color: theme-color("body");
    cursor: pointer;
    display: block;
    font-family: $font-family;
    font-size: px-to-rem(18px);
    padding: 15px 20px;
    text-align: center;
    text-decoration: none;
    transition: all 0.3s ease;

    @include if-tablet {
      font-size: px-to-rem(20px);

      &:hover {
        background: theme-color("accent-3");
        transform: scale(1.05);
      }
    }

    &:active {
      color: theme-color("black");
      background-color: theme-color("body");
    }

    &:focus {
      outline: none;
      box-shadow: theme-color("shadow-focus");
    }

    &.-light {
      background: theme-color("accent-3");

      &:hover {
        background: theme-color("accent-2");
      }
    }

    &.-large {
      font-size: px-to-rem(18px);

      @include if-tablet {
        font-size: px-to-rem(24px);
      }
    }
  }
}
</style>
